export function openRequestTrackingPage() {
  window.open("/request-tracking", "_blank", "noopener,noreferrer");
}
